import { Component, ViewEncapsulation } from "@angular/core";
import { ICellRendererAngularComp } from 'ag-grid-angular';

// Customizing ag-grid overlay component
// https://www.ag-grid.com/javascript-grid-loading-cell-renderer/
@Component({
  selector: "lib-custom-cell-loading-renderer",
  template:
    `<lib-skeleton #loadingSpinner type="text" [lines]="1"></lib-skeleton>`,
  encapsulation: ViewEncapsulation.None
})
export class CustomCellLoadingRendererComponent implements ICellRendererAngularComp {
  private params: any;

  agInit(params: any): void {
    this.params = params;
  }
  afterGuiAttached?(params: any): void {
  }
    
  refresh(params: any): boolean {
    return true;
  }

}
